import { jwtDecode } from 'jwt-decode';

interface JwtPayload {
	exp: number; // expiry timestamp (in seconds)
}

const isTokenExpired = (token: string | null): boolean => {
	if (!token) return true;

	try {
		const { exp } = jwtDecode<JwtPayload>(token);
		if (!exp) return true;
		return Date.now() >= exp * 1000;
	} catch {
		// invalid or malformed token
		return true;
	}
};

export default isTokenExpired;
